var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaylists(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Playlists__Icn/40px/Playlists",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Playlists__Color/Transp_00",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H40V40H0z",
    id: ".._.._src_svg_Icn_40px_Playlists__Rectangle"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M22,12 C23.1045695,12 24,12.8954305 24,14 L24,30 C24,31.1045695 23.1045695,32 22,32 L12,32 C10.8954305,32 10,31.1045695 10,30 L10,14 C10,12.8954305 10.8954305,12 12,12 L22,12 Z M22,14 L12,14 L12,30 L22,30 L22,14 Z M27,7 C28.1045695,7 29,7.8954305 29,9 L29,25 C29,26.1045695 28.1045695,27 27,27 L27,9 L15,9 C15,7.8954305 15.8954305,7 17,7 L27,7 Z M18,20 L18,22 L14,22 L14,20 L18,20 Z M20,17 L20,19 L14,19 L14,17 L20,17 Z",
    id: ".._.._src_svg_Icn_40px_Playlists__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylists);
export default __webpack_public_path__ + "static/media/Playlists.792505dd4ba7fa5a2fc2f2a9eb52dc59.svg";
export { ForwardRef as ReactComponent };